<template>
  <el-dialog
    title="管理员设置"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="90%"
  >
    <div class="admin-setting">
      <div class="search-section">
        <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
          <el-form-item label="综合查询">
            <el-input placeholder="请输入姓名/身份证号/手机号" v-model="formInline.search" style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="岗位">
            <el-input placeholder="请输入岗位" v-model="formInline.position" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="部门">
            <el-input placeholder="请输入部门" v-model="formInline.department" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="在职状态">
            <el-select v-model="formInline.status" placeholder="请选择在职状态" clearable style="width: 120px;">
              <el-option label="在职" value="1"></el-option>
              <el-option label="离职" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="账户状态">
            <el-select v-model="formInline.account_status" placeholder="请选择账户状态" clearable style="width: 120px;">
              <el-option label="正常" value="1"></el-option>
              <el-option label="禁用" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="付费类型">
            <el-select v-model="formInline.payment_type" placeholder="请选择付费类型" clearable style="width: 150px;">
              <el-option label="企业开通" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="员工身份">
            <el-select v-model="formInline.employee_identity" placeholder="请选择员工身份" clearable style="width: 150px;">
              <el-option label="正式员工" value="1"></el-option>
              <el-option label="临时员工" value="2"></el-option>
              <el-option label="外包员工" value="3"></el-option>
              <el-option label="实习员工" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="监督员身份">
            <el-select v-model="formInline.identity" placeholder="请选择监督员身份" clearable style="width: 150px;">
              <el-option label="安全监督员" value="1"></el-option>
              <el-option label="质量监督员" value="2"></el-option>
              <el-option label="环保监督员" value="3"></el-option>
              <el-option label="消防监督员" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="注册时间">
            <el-date-picker
              v-model="formInline.create_time_range"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              style="width: 240px;">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
            <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="table-section">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="name" label="姓名" width="100"></el-table-column>
          <el-table-column prop="id_card" label="身份证号" width="180"></el-table-column>
          <el-table-column prop="payment_type" label="付费类型" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.payment_type === '1'">企业开通</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="position" label="岗位" width="120"></el-table-column>
          <el-table-column prop="department" label="部门" width="120"></el-table-column>
          <el-table-column prop="job_title" label="职位" width="120"></el-table-column>
          <el-table-column prop="identity" label="身份" width="200">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.identity && scope.row.identity.includes('1')" size="mini" style="margin-right: 5px;">安全监督员</el-tag>
              <el-tag v-if="scope.row.identity && scope.row.identity.includes('2')" size="mini" style="margin-right: 5px;">质量监督员</el-tag>
              <el-tag v-if="scope.row.identity && scope.row.identity.includes('3')" size="mini" style="margin-right: 5px;">环保监督员</el-tag>
              <el-tag v-if="scope.row.identity && scope.row.identity.includes('4')" size="mini">消防监督员</el-tag>
              <span v-if="!scope.row.identity || scope.row.identity === ''">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="account_status" label="账号状态" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.account_status === '1' || scope.row.account_status === 1" type="success" size="mini">正常</el-tag>
              <el-tag v-else type="danger" size="mini">禁用</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === '1' || scope.row.status === 1" type="success" size="mini">在职</el-tag>
              <el-tag v-else type="danger" size="mini">离职</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="注册时间" width="160"></el-table-column>
          <el-table-column fixed="right" label="操作" width="280">
            <template slot-scope="scope">
              <el-button @click="detailClick(scope.row)" type="text" size="small">详情</el-button>
              <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="resignClick(scope.row)" type="text" size="small">离职</el-button>
              <el-button @click="resetPasswordClick(scope.row)" type="text" size="small">重置密码</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="submitAdminSetting" :loading="submitLoading">确 定</el-button>
    </div>

    <Detail :open_detail="open_detail" :ma_yg_id="ma_yg_id" v-if="open_detail" @close="closeDetail"></Detail>
    <Edit :open_add="open_edit" :ma_yg_id="ma_yg_id" v-if="open_edit" @close="closeEdit"></Edit>

    <el-dialog title="重置密码" :visible.sync="resetPasswordDialogVisible" @close='resetPasswordDialogVisible = false' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true" width="400px">
      <el-form :model="resetPasswordForm" :rules="resetPasswordRules" ref="resetPasswordForm" label-width="100px">
        <el-form-item label="新密码" prop="password">
          <el-input v-model="resetPasswordForm.password" type="password" placeholder="请输入新密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="resetPasswordForm.confirmPassword" type="password" placeholder="请再次输入新密码" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetPasswordDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitResetPassword">确 定</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
  import Ma_ygApi from '@/api/ma_yg.js';
  import Ma_companyApi from '@/api/ma_company.js';
  import Detail from '@/views/plus/ma_yg/index/part/detail.vue';
  import Edit from '@/views/plus/ma_yg/index/part/edit.vue';

  export default {
    components: {
      Detail,
      Edit,
    },
    props: {
      open_add: {
        type: Boolean,
        default: false
      },
      ma_company_id: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        dialogVisible: false,
        loading: true,
        submitLoading: false,
        tableData: [],
        pageSize: 20,
        totalDataNumber: 0,
        curPage: 1,
        formInline: {
          search: "",
          position: "",
          department: "",
          status: "",
          account_status: "",
          payment_type: "",
          employee_identity: "",
          identity: "",
          create_time_range: []
        },
        selectedRows: [],
        open_detail: false,
        open_edit: false,
        ma_yg_id: "",
        resetPasswordDialogVisible: false,
        resetPasswordForm: {
          password: '',
          confirmPassword: ''
        },
        resetPasswordRules: {
          password: [
            { required: true, message: '请输入新密码', trigger: 'blur' },
            { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
          ],
          confirmPassword: [
            { required: true, message: '请再次输入新密码', trigger: 'blur' }
          ]
        },
        currentResetUserId: null,
      };
    },
    created() {
      this.dialogVisible = this.open_add;
      if (this.open_add) {
        this.getData();
      }
    },
    watch: {
      open_add(newVal) {
        this.dialogVisible = newVal;
        if (newVal) {
          this.getData();
        }
      }
    },
    methods: {
      validateConfirmPassword(rule, value, callback) {
        if (value !== this.resetPasswordForm.password) {
          callback(new Error('两次输入的密码不一致'));
        } else {
          callback();
        }
      },
      dialogFormVisible() {
        this.$emit('close');
      },
      closeDetail() {
        this.open_detail = false;
      },
      closeEdit() {
        this.open_edit = false;
        this.getData();
      },
      handleSelectionChange(val) {
        this.selectedRows = val;
      },
      submitAdminSetting() {
        let self = this;
        if (this.selectedRows.length === 0) {
          this.$message.warning('请选择要设置为管理员的员工');
          return;
        }
        if (this.selectedRows.length > 1) {
          this.$message.warning('只能选择一个管理员');
          return;
        }
        
        let administratorId = this.selectedRows[0].ma_yg_id;
        
        self.$confirm('确定要将该员工设置为企业管理员吗?', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.submitLoading = true;
          Ma_companyApi.editadministrator({
            ma_company_id: self.ma_company_id,
            administrator: administratorId
          }, true)
          .then(data => {
            self.submitLoading = false;
            if (data.code == 1) {
              self.$message({
                message: '设置管理员成功',
                type: 'success'
              });
              self.dialogFormVisible();
            } else {
              self.$message.error(data.msg || '设置管理员失败');
            }
          })
          .catch(error => {
            self.submitLoading = false;
            self.$message.error('设置管理员失败');
          });
        })
        .catch(() => {});
      },
      getData() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.ma_company_id = self.ma_company_id;
        
        if (Params.create_time_range && Params.create_time_range.length === 2) {
          Params.start_time = Params.create_time_range[0];
          Params.end_time = Params.create_time_range[1];
        }
        delete Params.create_time_range;
        
        self.loading = true;
        Ma_ygApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
            self.loading = false;
          });
      },
      resetSearch() {
        this.formInline = {
          search: "",
          position: "",
          department: "",
          status: "",
          account_status: "",
          payment_type: "",
          employee_identity: "",
          identity: "",
          create_time_range: []
        };
        this.curPage = 1;
        this.getData();
      },
      handleCurrentChange(val) {
        this.curPage = val;
        this.getData();
      },
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getData();
      },
      detailClick(row) {
        this.ma_yg_id = row.ma_yg_id;
        this.open_detail = true;
      },
      editClick(row) {
        this.ma_yg_id = row.ma_yg_id;
        this.open_edit = true;
      },
      resignClick(row) {
        let self = this;
        self.$confirm('您确定要离职该员工吗?', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          Ma_ygApi.resign({
            ma_yg_id: row.ma_yg_id
          }, true)
          .then(data => {
            if (data.code == 1) {
              self.$message({
                message: '设置离职成功',
                type: 'success'
              });
              this.getData();
            } else {
              self.$message.error(data.msg || '设置离职失败');
            }
          })
          .catch(error => {
            self.$message.error('设置离职失败');
          });
        })
        .catch(() => {});
      },
      resetPasswordClick(row) {
        this.currentResetUserId = row.ma_yg_id;
        this.resetPasswordForm.password = '';
        this.resetPasswordForm.confirmPassword = '';
        this.resetPasswordDialogVisible = true;
        if (this.$refs.resetPasswordForm) {
          this.$refs.resetPasswordForm.clearValidate();
        }
      },
      submitResetPassword() {
        let self = this;
        if (this.resetPasswordForm.password !== this.resetPasswordForm.confirmPassword) {
          this.$message.error('两次输入的密码不一致');
          return;
        }
        this.$refs.resetPasswordForm.validate((valid) => {
          if (valid) {
            Ma_ygApi.resetPassword({
              ma_yg_id: self.currentResetUserId,
              password: self.resetPasswordForm.password
            }, true)
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: '重置密码成功',
                  type: 'success'
                });
                self.resetPasswordDialogVisible = false;
              } else {
                self.$message.error(data.msg || '重置密码失败');
              }
            })
            .catch(error => {
              self.$message.error('重置密码失败');
            });
          } else {
            return false;
          }
        });
      }
    }
  };
</script>

<style scoped>
.admin-setting {
  padding: 20px 0;
}

.search-section {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.table-section {
  margin-bottom: 20px;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_company/index/part/adminSetting.vue